"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAddress = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var formatAddress = exports.formatAddress = function formatAddress(_ref) {
  var firstLine = _ref.firstLine,
    secondLine = _ref.secondLine,
    city = _ref.city,
    region = _ref.region,
    postalCode = _ref.postalCode;
  var formattedSecondLine = (0, _isEmpty2["default"])(secondLine) ? '' : " ".concat(secondLine);
  return "".concat(firstLine).concat(formattedSecondLine, " ").concat(city, ", ").concat(region, " ").concat(postalCode);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/formatAddress.js
// module id = 2090
// module chunks = 9